import { z } from "zod";

export const customViewTypeSchema = z.enum(["Kanban"]);

export const kanbanStageSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string().default("#6B7280"),
  can_start: z.boolean().default(false),
  order: z.number().default(0),
  next_stage: z.array(z.object({ id: z.string(), name: z.string() })).default([]),
});

export const entityViewSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  slug: z.string().min(1),
  view_type: customViewTypeSchema,
  field_ref: z.string().nullable().optional(),
  card_fields: z.array(z.string()).default([]),
  enabled: z.boolean().default(true),
  stages: z.array(kanbanStageSchema).default([]),
  meta: z.record(z.string(), z.unknown()).nullable().optional(),
});

export const nativeEntityTypeSchema = z.enum([
  "recruitment_clients",
  "recruitment_jobs",
  "recruitment_candidates",
  "recruitment_applications",
  "contacts",
]);

export const entityTypeSchema = z.enum([
  "custom_model",
  "recruitment_clients",
  "recruitment_jobs",
  "recruitment_candidates",
  "recruitment_applications",
  "contacts",
]);

export type NativeEntityType = z.infer<typeof nativeEntityTypeSchema>;
export type EntityType = z.infer<typeof entityTypeSchema>;

export const NATIVE_ENTITY_CONFIG = {
  recruitment_clients: { settingsKey: "clients_settings", label: "Clients", slug: "clients", permission: "clients" },
  recruitment_jobs: { settingsKey: "jobs_settings", label: "Jobs", slug: "jobs", permission: "jobs" },
  recruitment_candidates: {
    settingsKey: "candidates_settings",
    label: "Candidates",
    slug: "candidates",
    permission: "candidates",
  },
  recruitment_applications: {
    settingsKey: "applications_settings",
    label: "Applications",
    slug: "applications",
    permission: "applications",
  },
  contacts: { settingsKey: "contacts_settings", label: "Contacts", slug: "contacts", permission: "contacts" },
} as const;

export type CustomViewType = z.infer<typeof customViewTypeSchema>;
export type KanbanStage = z.infer<typeof kanbanStageSchema>;
export type EntityView = z.infer<typeof entityViewSchema>;
